export const transformQuizData = (data) => {
  const quizCompletedData = {
    visible: false,
    multipleAttempts: true,
    nodes: {
      default: data.completed.image,
    },
    polygons: data.completed.polygons,
    solutionIndex: 0,
  };

  const quiz1Data = {
    visible: true,
    multipleAttempts: true,
    nodes: { default: data.q1.default, success: data.q1.success, fail: data.q1.fail },
    polygons: data.q1.polygons,
    solutionIndex: data.q1.solutionIndex,
  };

  const quizEarlyData = {
    visible: false,
    multipleAttempts: false,
    nodes: {
      default: data.q_early.default,
      success: data.q_early.success,
      fail: data.q_early.fail,
    },
    polygons: data.q_early.polygons,
    solutionIndex: data.q_early.solutionIndex,
  };

  const quizLateData = {
    visible: false,
    multipleAttempts: false,
    nodes: {
      default: data.q_late.default,
      success: data.q_late.success,
      fail: data.q_late.fail,
    },
    polygons: data.q_late.polygons,
    solutionIndex: data.q_late.solutionIndex,
  };

  return { quizCompletedData, quiz1Data, quizEarlyData, quizLateData };
};
